import {
  CellStyleModule,
  CheckboxEditorModule,
  ClientSideRowModelModule,
  ColumnAutoSizeModule,
  CustomEditorModule,
  CustomFilterModule,
  DateEditorModule,
  DateFilterModule,
  LargeTextEditorModule,
  ModuleRegistry,
  NumberEditorModule,
  NumberFilterModule,
  QuickFilterModule,
  RenderApiModule,
  SelectEditorModule,
  TextEditorModule,
  TextFilterModule,
  ValidationModule,
} from 'ag-grid-community'

ModuleRegistry.registerModules([
  CellStyleModule,
  CheckboxEditorModule,
  ClientSideRowModelModule,
  ColumnAutoSizeModule,
  CustomEditorModule,
  CustomFilterModule,
  DateEditorModule,
  DateFilterModule,
  LargeTextEditorModule,
  NumberEditorModule,
  NumberFilterModule,
  QuickFilterModule,
  RenderApiModule,
  SelectEditorModule,
  TextEditorModule,
  TextFilterModule,
  ValidationModule,
])
